export const header = {
  display: 'grid',
  padding: "20px 40px",
};

export const link = {
  width: 'fit-content'
}